// src/pages/About.jsx
import React from "react";
import "../styles/Home.css";
import Footer from '../components/Footer';

function About() {
  const APP_STORE_URL = "https://apps.apple.com/us/app/skroop/id6754806438";
  return (
    <div className="home-container">
      {/* Header */}
      <header className="header header--scrolled">
        <div className="header__background" />
        <div className="header__content">
          <div className="header__branding">
            <a href="/">
              <img src="/images/skroop_white_transparent_thick.png" alt="Skroop Logo" className="header__logo" />
            </a>
            <a href="/"><span className="header__title">Skroop</span></a>
          </div>
          <div className="header__actions">
            <a
              href={APP_STORE_URL}
              className="header__appstore"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                if (APP_STORE_URL === "#") {
                  e.preventDefault();
                }
              }}
            >
              <img
                src="/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                alt="Download on the App Store"
              />
            </a>
          </div>
        </div>
      </header>

      {/* About Content */}
      <section className="about" style={{ paddingTop: '8rem', background: '#f9f9f9', minHeight: '100vh' }}>
        <div className="about__content" style={{ maxWidth: '800px', margin: '0 auto', padding: '0 1rem' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '2rem', color: '#111' }}>
            About Skroop
          </h1>
          
          <div style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '3rem' }}>
            <p style={{ marginBottom: '1.5rem' }}>
              Skroop represents a renaissance of philosophical thought—a modern interpretation of timeless principles that have guided humanity for millennia.
            </p>
            
            <p style={{ marginBottom: '1.5rem' }}>
              We believe that virtue is a technology. Just as humans discovered they could cooperate in large numbers through shared stories, we recognize that the adaptation of virtue in our modern world is long overdue.
            </p>
            
            <p style={{ marginBottom: '1.5rem' }}>
              Our approach is both precise and principled. We deliver daily reflections on the Gospel—not as religious doctrine, but as stories of virtue that teach us about the effects of adherence, disregard, and restoration of morality in our lives.
            </p>
          </div>

          <h2 style={{ fontSize: '1.75rem', fontWeight: '600', marginBottom: '1.5rem', color: '#111' }}>
            Our Mission
          </h2>
          
          <p style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '3rem' }}>
            To provide clarity of virtue in an age that desperately needs both. Through daily homilies grounded in philosophical rigor, we help cultivate the four cardinal virtues: Prudence, Justice, Temperance, and Fortitude.
          </p>

          <h2 style={{ fontSize: '1.75rem', fontWeight: '600', marginBottom: '1.5rem', color: '#111' }}>
            Why Skroop?
          </h2>
          
          <p style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#444', marginBottom: '2rem' }}>
            Virtue is hard, but virtue sustains us. We all need daily reminders of morality—not through dogma, but through practical reflection on the principles that make humanity flourish.
          </p>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            {/*<a href="/signup" style={{
              backgroundColor: '#4f46e5',
              color: 'white',
              padding: '0.75rem 2rem',
              fontWeight: '600',
              fontSize: '1rem',
              textDecoration: 'none',
              borderRadius: '4px',
              display: 'inline-block'
            }}>
              Start Your Journey
            </a>*/}
          </div>
        </div>
      </section>

      <Footer />

    </div>
  );
}

export default About;
